<div class="container-fluid">
  <div class="filter">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Filtres
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-group">
          <app-select class="m-1" [label]="'type'" [formControl]="form_type" [list]="availableTypes"
            [isMultiple]="false" [isEnum]="true" enumName="EventType"
            (valueChanged)="updateDataFromFilters()"></app-select>

          <app-select class="m-1" [label]="'level'" [formControl]="form_level" [list]="availableLevels"
            [isMultiple]="false" [isEnum]="true" enumName="EventLevel"
            (valueChanged)="updateDataFromFilters()"></app-select>

          <app-input class="m-1" size="0" [label]="'dateStart'" type="datetime-local" [formControl]="form_dateStart"
            (valueChanged)="updateDataFromFilters()"></app-input>
          <app-input class="m-1" size="0" [label]="'dateEnd'" type="datetime-local" [formControl]="form_dateEnd"
            (valueChanged)="updateDataFromFilters()"></app-input>

          <app-input class="m-1" [label]="'input.user'" [formControl]="form_user" autocompletionType="users" size="0"
            [hasDeleteBtn]="form_user.value?.uid" [isDisabled]="form_user.value?.uid"
            (clickedOption)="onAddUser($event)" (clickedDelete)="onDeleteUser()"></app-input>

          <app-input class="m-1" [label]="'input.property'" [formControl]="form_property"
            autocompletionType="properties" size="0" [hasDeleteBtn]="form_property.value?.uid"
            [isDisabled]="form_property.value?.uid" (clickedOption)="onAddProperty($event)"
            (clickedDelete)="onDeleteProperty()"></app-input>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <button mat-mini-fab color="primary" class="white" appTooltip="Rafraîchir"
      (click)="updateDataFromFilters()"><mat-icon>refresh</mat-icon></button>
  </div>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner color="primary"></mat-spinner>
    </div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear
      matSortDirection="desc">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Date</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.date | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef>Niveau</th>
        <td mat-cell *matCellDef="let row">{{ row.level }}</td>
      </ng-container>
      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef>Détails</th>
        <td mat-cell *matCellDef="let row">{{ row.details }}
          <mat-icon *ngIf="row.stackTrace" class="filter-icon" color="primary" (click)="showStackTrace(row.stackTrace)"
            appTooltip="Voir la stacktrace">read_more</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef>Utilisateur</th>
        <td mat-cell *matCellDef="let row">{{ row.user }}
          <ng-container *ngIf="row.user">
            <mat-icon *ngIf="!form_user.value" class="filter-icon" color="primary" (click)="onAddUser(row.event.user)"
              appTooltip="Filtrer cet utilisateur (uid: {{row.event.user.uid}})">filter_alt</mat-icon>
            <mat-icon *ngIf="form_user.value" class="filter-icon" color="primary" (click)="onDeleteUser()"
              appTooltip="Supprimer le filtre">filter_alt_off</mat-icon>
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="propertyId">
        <th mat-header-cell *matHeaderCellDef>Bien</th>
        <td mat-cell *matCellDef="let row">{{ row.property }}
          <ng-container *ngIf="row.property">
            <mat-icon *ngIf="!form_property.value" class="filter-icon" color="primary"
              (click)="onAddProperty(row.event.property)"
              appTooltip="Filtrer ce bien  (uid: {{row.event.property.uid}})">filter_alt</mat-icon>
            <mat-icon *ngIf="form_property.value" class="filter-icon" color="primary" (click)="onDeleteProperty()"
              appTooltip="Supprimer le filtre">filter_alt_off</mat-icon>
            <mat-icon class="filter-icon" color="primary" (click)="goToProperty(row.event.property.uid)"
              appTooltip="Voir le bien">remove_red_eye</mat-icon>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class]="row.cssClass"></tr>
    </table>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="paging.pagingPageSize"
    [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
</div>